export const ThreeDots = () => {
  return (
    <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" r="1.5" transform="rotate(-180 2 2)" fill="#7B7B7B" />
      <circle cx="7" cy="2" r="1.5" transform="rotate(-180 7 2)" fill="#7B7B7B" />
      <circle cx="12" cy="2" r="1.5" transform="rotate(-180 12 2)" fill="#7B7B7B" />
    </svg>
  )
}
